module.exports = __webpack_public_path__ + "img/icon_camera.9b5dd28f.png";